function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { BgmStatistics } from 'modules/AmbulatoryGlucoseProfile';
import messages from 'modules/AmbulatoryGlucoseProfile/messages';
import * as patientResultsConstants from 'modules/PatientResults/constants';
import SectionTitle from '../components/SectionTitle';
import styles from './StatisticsSection.pcss';
var _React_Component;
class StatisticsSection extends (_React_Component = React.Component) {
    renderGlucoseTargetRanges() {
        const { conversion } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.statisticsSection,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "statisticsSection",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "statisticsSection__row",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__label",
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "statisticsSection__element",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.preMealTarget))
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__divider"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__value",
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "statisticsSection__element",
                                    children: `${patientResultsConstants.BEFORE_MEAL_TARGET[conversion.unit].min}
                -
                ${patientResultsConstants.BEFORE_MEAL_TARGET[conversion.unit].max}
                 ${conversion.unitSymbol}`
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "statisticsSection__row",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__label",
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "statisticsSection__element",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.postMealTarget))
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__divider"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "statisticsSection__value",
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "statisticsSection__element",
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.lessThan)),
                                        ` ${patientResultsConstants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].high}
                 ${conversion.unitSymbol}`
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.statisticsSectionWrapper,
            children: [
                /*#__PURE__*/ _jsx(SectionTitle, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.bgmStatistics))
                }),
                /*#__PURE__*/ _jsx(BgmStatistics, {
                    conversion: this.props.conversion,
                    readingsCount: this.props.readingsCount,
                    readingsPerDay: this.props.readingsPerDay,
                    readingsAverage: this.props.readingsAverage,
                    preMealAverage: this.props.preMealAverage,
                    postMealAverage: this.props.postMealAverage,
                    preMealCount: this.props.preMealCount,
                    postMealCount: this.props.postMealCount,
                    maxValue: this.props.maxValue,
                    minValue: this.props.minValue,
                    CV: this.props.CV
                }),
                /*#__PURE__*/ _jsx(SectionTitle, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.bgmTargets))
                }),
                this.renderGlucoseTargetRanges()
            ]
        });
    }
}
_define_property(StatisticsSection, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    readingsCount: PropTypes.number,
    readingsPerDay: PropTypes.string,
    readingsAverage: PropTypes.number,
    preMealAverage: PropTypes.number,
    postMealAverage: PropTypes.number,
    preMealCount: PropTypes.number,
    postMealCount: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    CV: PropTypes.number
});
export default withStyles(styles)(StatisticsSection);
